<template>
    <v-select
        :value="value"
        @input="$emit('input', $event)"
        :items="data"
        :loading="loading"
        :error-messages="[...errors, ...errorMessages]"
        :messages="messages"
        v-bind="$attrs">
    </v-select>
</template>

<script>
import { getPumps } from './../../services/scheduling/pumps';

export default {
    name: "PumpsSelect",
    props: {
        itemId: [String, Number],
        value: [String, Number],
        errorMessages: {
            default: () => [],
            type: Array
        }
    },
    data() {
        return {
            data: [],
            loading: false,
            errors: [],
            messages: []
        }
    },
    methods: {
        async fetchPumps() {
            try {
                this.loading = true;
                let resp = await getPumps();
                this.data = resp.data;
                this.loading = false;
            } catch(error) {
                this.setError(this.extractErrorMessage(error));
                this.loading = false;
            }
        },
        setError(error) {
            this.errors.push(error);
        },
        clearError() {
            this.errors = [];
        },
        extractErrorMessage(error) {
            return error.response ? error.response.data.message : error;
        },
        clearData() {
            this.data = [];
        },
        reset() {
            this.clearError();
            this.clearData();
        }
    },
    created() {
        this.fetchPumps();
    }
}
</script>

<style>

</style>